export default {
  title: "dark",

  colors: {
    primary: "#333",
    secundary: "#c62e65",

    background: "#222",
    text: "#fff",
    button: "#c62e65",
    input: "rgba(0, 0, 0, 0.3)",
  },
};
